"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable max-len */

/* eslint-disable no-unused-vars */

/* eslint-disable no-undef */

var ROOT_URL = {
  DEV: 'https://k.dev-apiairasia.com/',
  STG: 'https://k.stg-apiairasia.com/',
  PREPROD: 'https://k.preprod-apiairasia.com/',
  PROD: 'https://k.airasia.com/'
};
var EnvironmentUrl = {
  DEVELOPMENT: {
    GCS_URL: 'https://ppsch.apiairasia.com/',
    SSR_URL: ROOT_URL.DEV,
    SSR_DATA_PATH: 'ssr/getssrdata'
  },
  STAGING: {
    GCS_URL: 'https://ppsch.apiairasia.com/',
    SSR_URL: ROOT_URL.STG,
    SSR_DATA_PATH: 'ssr/getssrdata'
  },
  PRODUCTION: {
    GCS_URL: 'https://sch.apiairasia.com/',
    SSR_URL: ROOT_URL.PROD,
    SSR_DATA_PATH: 'ssr/getssrdata'
  },
  PRE_PRODUCTION: {
    GCS_URL: 'https://sch.apiairasia.com/',
    SSR_URL: ROOT_URL.PREPROD,
    SSR_DATA_PATH: 'ssr/getssrdata'
  }
};
var _default = EnvironmentUrl;
exports.default = _default;